'use client';

import { c } from '../../../utils/tailwind-merge';
import { SheetPropsData } from '../../molecules/Sheets/Sheets.types';
import { SheetsStack } from '../../molecules/Sheets/SheetsStack';
import {
  TabsContent,
  TabsList,
  TabsRoot,
  TabsTrigger,
} from '../../molecules/Tabs/Tabs';
import { PackageList } from '../PackageList/PackageList';
import { ProductOverview } from '../ProductOverview/ProductOverview';
import { ReleaseList } from '../ReleaseList/ReleaseList';
import { ReviewList } from '../ReviewList';
import { ProductTabsProps } from './ProductTabs.types';

export const ProductTabs = ({
  microcopy,
  overview,
  packages,
  releases,
  reviews,
  value,
  onOpenInUnityFromPackage,
  onValueChange,
  onAccordionChange,
  onHelpfulVotesReview,
  onEditReview,
  onDeleteReview,
  onHelpfulVotesReply,
  onEditReply,
  onDeleteReply,
  onSubmitReply,
  onFilter,
  onSort,
  onPageChange,
  onSubmitReport,
  onFilterReviews,
  onWriteReview,
  className = '',
}: ProductTabsProps) => {
  const reviewListProps =
    reviews && microcopy.reviews
      ? {
          reviewStars: reviews.reviewStars,
          canWriteReview: reviews.canWriteReview,
          reviewList: reviews.reviewList,
          microcopy: microcopy.reviews,
          reviews: reviews.reviews,
          onHelpfulVotesReview,
          onEditReview,
          onDeleteReview,
          onHelpfulVotesReply,
          onEditReply,
          onDeleteReply,
          onSubmitReply,
          onFilter,
          onSort,
          onPageChange,
          onSubmitReport,
          onFilterReviews,
          onWriteReview,
          start: reviews.start,
          end: reviews.end,
          total: reviews.total,
          currentPage: reviews.currentPage,
          totalPages: reviews.totalPages,
          className: 'mt-8 md:mt-0',
        }
      : null;

  const mobileSheetDataWrapper: SheetPropsData[] = [
    {
      label: microcopy.tabs.overview,
      children: (
        <ProductOverview {...overview} microcopy={microcopy.overview} />
      ),
    },
    {
      label: microcopy.tabs.packages,
      children: (
        <PackageList
          {...packages}
          microcopy={microcopy.packages}
          onOpenInUnityFromPackage={onOpenInUnityFromPackage}
          onAccordionChange={onAccordionChange}
        />
      ),
    },
    {
      label: microcopy.tabs.releases,
      children: <ReleaseList {...releases} microcopy={microcopy.releases} />,
    },
    ...(reviewListProps
      ? [
          {
            label: microcopy.tabs.reviews,
            children: <ReviewList {...reviewListProps} />,
          },
        ]
      : []),
  ];

  return (
    <section className={c('w-full', className)} id="product-tabs">
      <section className="hidden md:block">
        <TabsRoot value={value} onValueChange={onValueChange}>
          <TabsList>
            <TabsTrigger value="overview">
              {microcopy.tabs.overview}
            </TabsTrigger>
            <TabsTrigger value="packages">
              {microcopy.tabs.packages}
            </TabsTrigger>
            <TabsTrigger value="releases">
              {microcopy.tabs.releases}
            </TabsTrigger>
            {reviews ? (
              <TabsTrigger value="reviews">
                {microcopy.tabs.reviews}
              </TabsTrigger>
            ) : null}
          </TabsList>

          <TabsContent value="overview" forceMount={true}>
            <ProductOverview {...overview} microcopy={microcopy.overview} />
          </TabsContent>
          <TabsContent value="packages" forceMount={true}>
            <PackageList
              {...packages}
              microcopy={microcopy.packages}
              onOpenInUnityFromPackage={onOpenInUnityFromPackage}
              onAccordionChange={onAccordionChange}
            />
          </TabsContent>
          <TabsContent value="releases" forceMount={true}>
            <ReleaseList
              {...releases}
              microcopy={microcopy.releases}
              onAccordionChange={onAccordionChange}
            />
          </TabsContent>
          {reviewListProps ? (
            <TabsContent value="reviews" forceMount={true}>
              <ReviewList {...reviewListProps} />
            </TabsContent>
          ) : null}
        </TabsRoot>
      </section>

      <section className="block md:hidden">
        <SheetsStack
          sheets={mobileSheetDataWrapper}
          microcopy={microcopy.sheet}
          className="pt-0"
        />
      </section>
    </section>
  );
};
